const initialState = {
  pathname: undefined,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case 'LOCATION_CHANGE': {
      const pathName = action.payload.location.pathname;
      return { ...state, pathName };
    }
    default:
      return state;
  }
}
